define([
	"dojo/_base/declare",
	"csi/property/Widget",
	"./VersionView"
], function(declare,Widget,VersionView) {

	return declare([Widget,VersionView]);
});